import React from "react";

import { DateTime } from "luxon";

import { noValueText } from "components/sensors/table/no-value-text";

export const DATE_FORMAT = "yyyy/MM/dd HH:mm:ss";

// Dates are shown/copied in the viewer's local timezone with no offset in
// the value itself (keeps it a real parseable date in Excel/Sheets), so the
// offset goes in the column headerName instead -- e.g. "Last Seen (GMT+10)".
// Baked into headerName (not renderHeader) so it also shows up in CSV
// export, which reads headerName directly.
export const localTimezoneLabel = () => DateTime.local().toFormat("ZZZZ");

// Props for a date-displaying CopyableCell: shows relative time ("2 hours
// ago"), copies/announces the absolute value, and shows the absolute value
// in a tooltip on hover. When date is null, shows noValueLabel instead.
export function copyableDateCellProps(
  date: DateTime | null,
  noValueLabel = "No readings",
): {
  value: string;
  children?: React.ReactNode;
  tooltip?: string;
} {
  if (!date) {
    return { value: "", children: noValueText(noValueLabel) };
  }
  const absolute = date.toFormat(DATE_FORMAT);
  return {
    value: absolute,
    children: date.toRelative(),
    tooltip: absolute,
  };
}
